"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionContext = void 0;
const react_1 = require("react");
/**
 * Form subscription context.
 */
exports.SubscriptionContext = (0, react_1.createContext)(undefined);
//# sourceMappingURL=subscription-context.js.map